import React, { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import DeleteModal from "../../components/atoms/DeleteModal";
import InputGroup from "../../components/atoms/InputGroup";
import Loading from "../../components/atoms/Loading";
import TitleDetail from "../../components/atoms/TitleDetail";
import Navbar from "../../components/main/Navbar";
import Table from "../../components/main/Table";
import EditeOrderModal from "../../components/orderpage/EditeOrderModal";
import OrderLogHeader from "../../components/orderpage/OrderLogHeader";
import { OrderLogUseContext } from "../../context/AdminDashboard/OrderLogContext";
import { HeaderOrderDetail } from "../../data/TablesHeader";

const OrderLog = () => {
  const {
    name,
    status,
    orderNumber,
    orderdate,
    getorderDetail,
    reciver,
    phoneNumber,
    postalcode,
    city,
    address,
    totalAmount,
    paymentMethod,
    transactionNumber,
    Amount,
    deliverycost,
    orderTable,
    loaded,
    deliverycode,
    editOrder,
    showModal,
    closeModal,
    changestatus,
    onchangeInput,
    doneEdit,
    showDeleteModal,
    closeDeleteModal,
    RemoveItem,
    onDelete,
  } = OrderLogUseContext();

  useEffect(() => {
    getorderDetail();
    document.title = "جزئیات سفارش";
  }, []);

  return (
    <>
      <div className="pb-7.5px">
        <Navbar titles={["سفارش‌ها", "جزئیات سفارش آرش فکری"]} />
        {loaded ? (
          <Loading height="h-80" />
        ) : (
          <div
            className="mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px "
            dir="rtl">
            <OrderLogHeader
              name={name}
              status={status}
              editOrder={editOrder}
              onDelete={onDelete}
            />
            <TitleDetail title={"اطلاعات کلی"} />
            <div className="flex flex-row justify-between w-full gap-5 mt-25">
              <InputGroup
                iconName={"box-search"}
                label="شماره سفارش (پیگیری)"
                value={orderNumber}
                readOnly={true}
              />
              <InputGroup
                iconName={"calendar"}
                label="تاریخ ثبت سفارش"
                value={orderdate}
                readOnly={true}
              />
              <InputGroup
                iconName={"search-status"}
                label="وضعیت فعلی"
                value={status}
                readOnly={true}
              />
            </div>
            <TitleDetail title={"اطلاعات گیرنده سفارش"} />
            <div className="flex flex-row justify-between w-full gap-5 mt-25">
              <InputGroup
                iconName={"userF"}
                label="تحویل گیرنده"
                value={reciver}
                readOnly={true}
              />
              <InputGroup
                iconName={"call"}
                label="شماره تلفن همراه"
                value={phoneNumber}
                readOnly={true}
              />
              <InputGroup
                iconName={"discover"}
                label="کد پستی"
                value={postalcode}
                readOnly={true}
              />
            </div>

            <div className="flex flex-row justify-between w-full gap-5 mt-25 ">
              <InputGroup
                iconName={"global"}
                label="استان و شهر"
                value={city}
                readOnly={true}
                width="w-1/3"
              />
              <InputGroup
                iconName={"gps"}
                label="آدرس گیرنده"
                value={address}
                readOnly={true}
                width="w-2/3"
              />
            </div>
            <TitleDetail title={"اطلاعات پرداخت"} />
            <div className="flex flex-row justify-between w-full gap-5 mt-25">
              <InputGroup
                iconName={"coin"}
                label="مبلغ سفارش"
                value={totalAmount}
                readOnly={true}
              />
              <InputGroup
                iconName={"bank"}
                label="نحوه پرداخت"
                value={paymentMethod}
                readOnly={true}
              />
              <InputGroup
                iconName={"card-tick"}
                label="شماره تراکنش"
                value={transactionNumber}
                readOnly={true}
              />
            </div>
            <TitleDetail title={"اطلاعات مرسوله ارسالی"} />
            <div className="flex flex-row justify-between w-full gap-5 mt-25">
              <InputGroup
                iconName={"coin"}
                label="مبلغ مرسوله"
                value={Amount}
                readOnly={true}
              />
              <InputGroup
                iconName={"bank"}
                label="هزینه ارسال"
                value={deliverycost}
                readOnly={true}
              />
              <InputGroup
                iconName={"card-tick"}
                label="کد پیگیری سرویس ارسال"
                value={deliverycode}
                readOnly={true}
              />
            </div>
            <div className="mt-25 pb-7.5px ">
              <Table
                thData={HeaderOrderDetail}
                tableData={orderTable}
                thwidth="w-27.1"
              />
            </div>
            <EditeOrderModal
              doneEdit={doneEdit}
              onchangeInput={onchangeInput}
              onchangeselect={changestatus}
              codeval={deliverycode}
              status={status}
              showModal={showModal}
              closeModal={closeModal}
            />
            <DeleteModal
              text={`آیا برای حذف سفارش“${orderNumber}” مطمئن هستید؟`}
              showDeleteModal={showDeleteModal}
              closeDeleteModal={closeDeleteModal}
              RemoveItem={RemoveItem}
            />
          </div>
        )}
        {/* <Toaster/> */}
      </div>
    </>
  );
};

export default OrderLog;
